import {UiConfigRendererBlueprint} from "./UiConfigRendererBlueprint";

class UI extends UiConfigRendererBlueprint{

}

export {UiConfigRendererBlueprint, UI};

